// Election dates surfaced throughout the app (hero countdowns, ballot logistics).
// TODO: hydrate from /api/election-calendars once the ballot screen lands; these
// defaults mirror the 2026 Colorado cycle used by the design prototype.
export const ELECTION = {
  primary: '2026-06-30',
  general: '2026-11-03',
};

export type Election = typeof ELECTION;
